import React from 'react';

const CompanyNoteFormModal = React.lazy(() => import('../components/FormModal'));
const companyNoteModalRegistry = {
    personalize_companyNoteId: CompanyNoteFormModal
};
export default companyNoteModalRegistry;
